import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import CommunicationsView from './view/CommunicationsView';
import CommunicationsDetails from './details/CommunicationsDetails';

import buttons from './CommunicationsButtons';
import events from './CommunicationsEvents';

import en from './i18n/en';
import it from './i18n/it';
import CommunicationsListItem from './CommunicationsListItem';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('communications'),
	routes: [
		{
			path: 'communications/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'communications'),
			element: (
				<DetailsPage
					key="communications/add"
					module="communications"
					headerOptions={{ showAvatar: true }}
					tabs={CommunicationsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'communications/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'communications'),
			element: (
				<DetailsPage
					key="communications/details"
					module="communications"
					headerOptions={{ showAvatar: true }}
					tabs={CommunicationsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'communications/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'communications'),
			element: (
				<ViewPage
					key="communications/view"
					module="communications"
					content={{ type: 'tabs', tabs: CommunicationsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
